import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CoverHeroComponent } from 'src/app/components/cover-hero/cover-hero.component';
import { CoverSignupComponent } from '../../app/components/cover-signup/cover-signup.component';
import { CoverLoginComponent } from '../../app/components/cover-login/cover-login.component';
import { MatTabsModule } from '@angular/material/tabs';
import {
  AnalyticsLoggerService,
  GENERAL_EVENTS,
} from 'src/app/services/analytics-logger.service';

@Component({
  selector: 'cover',
  imports: [
    MatButtonModule,
    CommonModule,
    MatIconModule,
    CoverHeroComponent,
    CoverSignupComponent,
    CoverLoginComponent,
    MatTabsModule,
  ],
  standalone: true,
  templateUrl: './cover.component.html',
  styleUrls: ['./cover.component.scss'],
})
export class CoverComponent implements OnInit {
  isShown = false;
  state: 'hero' | 'login' | 'signup' = 'hero';

  @Input() public initialState: 'login' | 'signup' | 'hero' = 'hero';

  @Output() public onClose = new EventEmitter();

  constructor(private analyticsLogger: AnalyticsLoggerService) {}

  ngOnInit(): void {
    this.state = this.initialState;
    this.isShown = false;
    setTimeout(() => (this.isShown = true), 0);
  }

  heroOrClose() {
    if (this.state === 'hero') {
      this.analyticsLogger.logEvent(GENERAL_EVENTS.demoTried);
      this.close();
    } else if (this.initialState === 'hero') {
      this.state = 'hero';
    } else {
      this.analyticsLogger.logEvent(GENERAL_EVENTS.demoTried);
      this.close();
    }
  }

  close() {
    this.isShown = false;
    this.initialState = 'hero';
    setTimeout(() => this.onClose.emit(), 200);
  }

  getSelectedIndex() {
    switch (this.state) {
      case 'hero':
        return 0;
      case 'signup':
        return 1;
      case 'login':
        return 2;
    }
  }
}
